
@if (control) {
  <div class="block relative">
    @if (!hideLabel) {
      <label class="input-label" [for]="id+'_sub'">{{fullLabel}}
        <ng-content select="label"></ng-content>
      </label>
    }
    <div class="relative shadow-sm">
      <select class="input" [id]="id+'_sub'" [formControl]="control" [class.input-invalid]="!control.valid &amp;&amp; control.enabled &amp;&amp; control.touched" [attr.aria-invalid]="!control.valid &amp;&amp; control.enabled &amp;&amp; control.touched" [attr.aria-describedby]="id+'_sub_error'">
        @if (emptySelection) {
          <option [value]="''">{{emptySelectionText}}</option>
        }
        @if (!emptySelection) {
          <option [value]="''" disabled selected>{{emptySelectionText}}</option>
        }
        @for (t of values; track t) {
          <option [value]="t.id">{{t.value}}</option>
        }
      </select>@if (!control.valid && control.enabled && control.touched) {
      <span class="input-invalid-hint" [id]="id+'_sub_error'">{{ control.value | inputErrorMessage:control }}</span>
    }
  </div>
</div>
}